
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default Vue.extend({
	name: 'MarkOnFileBadge',
	components: {
		FontAwesomeIcon
	},
	props: {
		documentRequestId: {
			type: Number,
			required: true
		},
		matchCount: {
			type: Number,
			required: true
		},
		documentName: {
			type: String,
			required: true
		}
	},
	computed: {
		tooltip(): string {
			const count = this.matchCount;
			const plural = count === 1 ? 'document' : 'documents';
			return `${count} potential matching ${plural} found on file for ${this.documentName}. Click to view and select.`;
		}
	}
});
